"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsDiscountEditViewModel = instanceOfProductPromotionsDiscountEditViewModel;
exports.ProductPromotionsDiscountEditViewModelFromJSON = ProductPromotionsDiscountEditViewModelFromJSON;
exports.ProductPromotionsDiscountEditViewModelFromJSONTyped = ProductPromotionsDiscountEditViewModelFromJSONTyped;
exports.ProductPromotionsDiscountEditViewModelToJSON = ProductPromotionsDiscountEditViewModelToJSON;
exports.ProductPromotionsDiscountEditViewModelToJSONTyped = ProductPromotionsDiscountEditViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsDiscountEditViewModel interface.
 */
function instanceOfProductPromotionsDiscountEditViewModel(value) {
    return true;
}
function ProductPromotionsDiscountEditViewModelFromJSON(json) {
    return ProductPromotionsDiscountEditViewModelFromJSONTyped(json, false);
}
function ProductPromotionsDiscountEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wsppdPromotionsDiscountNo': json['wsppdPromotionsDiscountNo'] == null ? undefined : json['wsppdPromotionsDiscountNo'],
        'wsppdOrgId': json['wsppdOrgId'] == null ? undefined : json['wsppdOrgId'],
        'wsppdPromotionsNo': json['wsppdPromotionsNo'] == null ? undefined : json['wsppdPromotionsNo'],
        'wsppdDiscountName': json['wsppdDiscountName'] == null ? undefined : json['wsppdDiscountName'],
        'wsppdDiscountCode': json['wsppdDiscountCode'] == null ? undefined : json['wsppdDiscountCode'],
        'wsppdUseWay': json['wsppdUseWay'] == null ? undefined : json['wsppdUseWay'],
        'wsppdDiscountWay': json['wsppdDiscountWay'] == null ? undefined : json['wsppdDiscountWay'],
        'wsppdFullAmount': json['wsppdFullAmount'] == null ? undefined : json['wsppdFullAmount'],
        'wsppdMinQuantity': json['wsppdMinQuantity'] == null ? undefined : json['wsppdMinQuantity'],
        'wsppdDiscountValue': json['wsppdDiscountValue'] == null ? undefined : json['wsppdDiscountValue'],
        'wsppdUseStatus': json['wsppdUseStatus'] == null ? undefined : json['wsppdUseStatus'],
        'wsppdLimitMaterial': json['wsppdLimitMaterial'] == null ? undefined : json['wsppdLimitMaterial'],
        'wsppdDiscountDescription': json['wsppdDiscountDescription'] == null ? undefined : json['wsppdDiscountDescription'],
    };
}
function ProductPromotionsDiscountEditViewModelToJSON(json) {
    return ProductPromotionsDiscountEditViewModelToJSONTyped(json, false);
}
function ProductPromotionsDiscountEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wsppdPromotionsDiscountNo': value['wsppdPromotionsDiscountNo'],
        'wsppdOrgId': value['wsppdOrgId'],
        'wsppdPromotionsNo': value['wsppdPromotionsNo'],
        'wsppdDiscountName': value['wsppdDiscountName'],
        'wsppdDiscountCode': value['wsppdDiscountCode'],
        'wsppdUseWay': value['wsppdUseWay'],
        'wsppdDiscountWay': value['wsppdDiscountWay'],
        'wsppdFullAmount': value['wsppdFullAmount'],
        'wsppdMinQuantity': value['wsppdMinQuantity'],
        'wsppdDiscountValue': value['wsppdDiscountValue'],
        'wsppdUseStatus': value['wsppdUseStatus'],
        'wsppdLimitMaterial': value['wsppdLimitMaterial'],
        'wsppdDiscountDescription': value['wsppdDiscountDescription'],
    };
}
